export default {
    large: 30,
    medium: 15,
    small: 5
}